import { CheckCircleOutlined, HighlightOffOutlined } from '@mui/icons-material'
import { Grid, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { Field, FieldProps } from 'formik'

import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

interface IProps {
  name: string // formik field name
  options: { value: string; label: string; disabled?: boolean; disabledTooltip?: string }[]
}

const FormikPreferencesToggleButton = ({ name, options }: IProps) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles

  const handleChange = (newValue: string, setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void) => {
    setFieldValue(name, newValue)
  }

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const { setFieldValue } = form
        return (
          <ToggleButtonGroup value={field.value} onChange={(_e, newValue) => handleChange(newValue, setFieldValue)} sx={classes.toggleButtonGroup}>
            {options.map((option) => {
              const selected = field.value.includes(option.value)
              if (option.disabled && option.disabledTooltip)
                return (
                  <ToggleButton key={option.value} value={option.value} disabled={option.disabled} aria-label={option.label} sx={classes.toggleButton}>
                    <Tooltip title={option.disabledTooltip ?? ''}>
                      <Grid container={true} sx={[sharedClasses.centerContentVertical, { flexDirection: 'column' }]}>
                        {selected ? <CheckCircleOutlined htmlColor="rgba(0, 0, 0, 0.38)" /> : <HighlightOffOutlined htmlColor="rgba(0, 0, 0, 0.38)" />}
                        {option.label}
                      </Grid>
                    </Tooltip>
                  </ToggleButton>
                )
              return (
                <ToggleButton key={option.value} value={option.value} disabled={option.disabled} aria-label={option.label} sx={classes.toggleButton}>
                  {selected ? <CheckCircleOutlined htmlColor="#0078EC" /> : <HighlightOffOutlined htmlColor="rgba(0, 0, 0, 0.38)" />}
                  {option.label}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>
        )
      }}
    </Field>
  )
}

export default FormikPreferencesToggleButton
